import { API_URL } from '../assets/constants/apiUrl'
import { CRM_API_URL } from '../assets/constants/crmApi'

export const AUTH_LOGIN_URL = `${CRM_API_URL}login?amember_redirect_url=${API_URL}session_renew`
export const AUTH_LOGOUT_URL = `${CRM_API_URL}logout`
export const AUTH_SIGNUP_URL = `${CRM_API_URL}signup?amember_redirect_url=${API_URL}session_renew`
export const AUTH_PRICING_URL = `${CRM_API_URL}pricing?amember_redirect_url=${API_URL}session_renew`
export const AUTH_SIGNUP_URL_PRICING = `${CRM_API_URL}signup?amember_redirect_url=${API_URL}pricing`
export const AUTH_LOGIN_URL_PRICING = `${CRM_API_URL}login?amember_redirect_url=${API_URL}pricing`
